import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable({ providedIn:'root' })
export class ImageService {

  constructor(private http: HttpClient) {
  }

  downloadImage(path: string, onLoadend: (base64data: string) => void) {
    // @ts-ignore
    this.http.get(path, {
      responseType: 'blob' // this tells angular to parse it
      // as a blob, default is json
    }).subscribe((res: Blob) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        var base64data = reader.result;
        if (base64data && typeof base64data === 'string') {
          onLoadend(base64data);
        }
      }

      reader.readAsDataURL(res);
    });
  }
}
